<template>
  <div>
    <div class="breadcrumb-box btrr-10 mb-10">
      <div class="plc"><i class="el-icon-s-home" style="font-size: 18px; color: #FFF;"></i></div>
      <div class="triangle"></div>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: 50px;">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>About Us</el-breadcrumb-item>
          <el-breadcrumb-item>Company Introduction</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="content">
      <div class="mb-10 bs-10 br-10" style="padding:10px; border: 1px solid #e8e8e8;margin-top: 10px;margin-right: 10px;">
        <div class="pic"><el-image :src="aboutImage" class="br-10" :fit="fit" style="width: 100%; height: 100%;"></el-image></div>
        <div class="h-20"></div>
        <div class="text" v-html="aboutData_1.content"></div>
      </div>
      <div class="mb-10 bs-10 br-10" style="padding:10px; border: 1px solid #e8e8e8;margin-top: 10px;margin-right: 10px;">
        <div class="title">Yiree Environment</div>
        <div class="h-20"></div>
        <el-row :gutter="10" class="m-t-10">
          <el-col :span="12" v-for="(e_image,index) in aboutData_2.imageList" :key="index">
            <div class="e-image-box">
              <div class="e-image"><el-image class="br-10" :src="e_image.url" :fit="fit" style="height: 100%; border: 1px solid #e8e8e8;"></el-image></div>
              <div class="image-title">{{e_image.title}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="mb-10 bs-10 br-10" style="padding:10px; border: 1px solid #e8e8e8;margin-top: 10px;margin-right: 10px;">
        <div class="title">Yiree Certificate</div>
        <div class="h-20"></div>
        <el-row :gutter="10" class="m-t-10">
          <el-col :span="8" v-for="(h_image,index) in aboutData_3.imageList" :key="index">
            <div class="h-image-box">
              <div class="h-image"><el-image :src="h_image.url" :fit="fit" class="br-10 b" style="height: 100%"></el-image></div>
              <div class="image-title">{{h_image.title}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="h-60"></div>
  </div>
</template>

<script>
  export default {
    name: 'About',
    data() {
      return {
        fit: 'fit',
        about_text: '',
        aboutData: {},
        aboutData_1: {},
        aboutData_2: {},
        aboutData_3: {},
        aboutImage: ''
      }
    },
    methods: {
      getAbout() {
      	this.$axios.get('/api/about/about').then(res => {
      			//console.log(res.data);
      			if (res.data.code == '0') {
              let aboutData = this.aboutData = res.data.data;
              for(let i=0;i<aboutData.length;i++){
                if(aboutData[i].title == '企业环境'){
                  this.aboutData_2 = aboutData[i];
                }else if(aboutData[i].title == '资质荣誉'){
                  this.aboutData_3 = aboutData[i];
                }else if(aboutData[i].title == '企业介绍'){
                  this.aboutData_1 = aboutData[i];
                  this.aboutImage = this.aboutData_1.coverImage;
                }
              }
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
    },
    mounted: function () {
      this.getAbout();
    }
  }
</script>

<style scoped>
  .about-container {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
  }

  .plc {
    width: 50px;
    height: 50px;
    line-height: 50px;
    background-color: #AA0000;
    float: left;
  }

  .triangle {
    float: left;
    width: 0;
    height: 0;
    border: 25px solid;
    border-color: transparent transparent transparent #AA0000;
  }

  .breadcrumb {
    height: 40px;
    line-height: 40px;
    float: left;
    font-size: 18px;
  }

  .breadcrumb-box {
    height: 50px;
    line-height: 50px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    border-bottom:1px solid #e8e8e8;
  }

  .active {
    color: #AA0000;
  }

  .pic {
    max-height: 400px;
    /*background-color: #DCDFE6;*/
    margin-bottom: 10px;
  }

  .content .text {
    text-align: left;
    font-size: 15px;
    text-align: justify;
    line-height: 24px;
  }

  .content .title {
    margin: 30px auto;
    font-size: 24px;
    font-weight: bold;
  }

  .bg {
    background-color: #DCDFE6;
  }

  /*.b {
    border: 1px solid #E8E8E8;
  }*/

  .e-image {
    width: 100%;
    height: 250px;
  }

  .image-title {
    margin-top: 20px;
    margin-bottom: 20px;
    height: 20px;
  }

  .h-image {
    width: 100%;
    height: 400px;
  }

  .m-t-10 {
    margin-top: 10px;
  }

  .h-20 {
    height: 20px;
  }

  .h-60 {
    height: 60px;
  }

  .btlr-10 {
    border-top-left-radius: 10px;
  }
  .btrr-10 {
    border-top-right-radius: 10px;
  }
  .bblr-10 {
    border-bottom-left-radius: 10px;
  }
  .bbrr-10 {
    border-bottom-right-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AboutCompany.vue